import * as api from '../api/account';

export const getAccount = (id) => async (dispatch) => {
  try {
     dispatch({ type: 'START_LOADING'});
      const { data } = await api.fetchAccount(id);

      dispatch({ type: 'FETCH_ACCOUNT', payload: data });
      dispatch({ type: 'STOP_LOADING'});
  } catch (error) {
      console.log(error.message);
  }
}

export const getAccounts = () => async (dispatch) => {
  try {
     dispatch({ type: 'START_LOADING'});
      const { data } = await api.fetchAccounts();

      dispatch({ type: 'FETCH_ACCOUNTS', payload: data });
      dispatch({ type: 'STOP_LOADING'});
  } catch (error) {
      console.log(error.message);
  }
}

export const updateProfile = ( id, formData, navigate) => async (dispatch) => {
  try {
    dispatch({ type: 'START_LOADING'});
    const { data } = await api.updateProfile(id, formData);

    dispatch({ type: 'UPDATEPROFILE', payload: data})
    navigate(`/${formData.userName}/dashboard/${id}`);
    dispatch({ type: 'STOP_LOADING'});
  } catch (error) {
    console.log(error);
  }
}

export const updatePassword = ( id, formData, navigate, user) => async (dispatch) => {
  try {
    dispatch({ type: 'START_LOADING'});
    const { data } = await api.updatePassword(id, formData);

    dispatch({ type: 'UPDATEPASSWORD', payload: data})
    navigate(`/${user.result.userName}/dashboard/${id}`);
    dispatch({ type: 'STOP_LOADING'});
  } catch (error) {
    console.log(error);
  }
}

export const sendMSG = (msgDets, userID) => async (dispatch) => {
  try {
    dispatch({ type: 'START_SENDING'});
    const {data} = await api.msg(msgDets, userID);
    
    dispatch({ type: 'MSG', payload: data})
    
    dispatch({ type: 'STOP_SENDING'});
    return data.liveChats;
  } catch (error) {
    console.log(error);
  }
}

export const updateMsgCounterSupport = (current, userID) => async (dispatch) => {
  try {
    const {data} = await api.updateMsgCounterSupport(current, userID);
    
    dispatch({ type: 'UPDATE', payload: data})
  } catch (error) {
    console.log(error);
  }
}

export const transfer = ( id, formData, navigate, user) => async (dispatch) => {
  try {
    dispatch({ type: 'START_LOADING'});
    const { data } = await api.transfer(id, formData);

    dispatch({ type: 'TRANSFER', payload: data})
    navigate(`/${user.result.userName}/dashboard/${id}`);
    dispatch({ type: 'STOP_LOADING'});
  } catch (error) {
    console.log(error);
  }
}

export const deposit = ( id, formData, navigate, user) => async (dispatch) => {
  try {
    dispatch({ type: 'START_LOADING'});
    const { data } = await api.deposit(id, formData);

    dispatch({ type: 'DEPOSIT', payload: data})
    navigate(`/${user.result.userName}/dashboard/${id}`);
    dispatch({ type: 'STOP_LOADING'});
  } catch (error) {
    console.log(error);
    dispatch({ type: 'STOP_LOADING'});
  }
}

export const withdraw = ( id, formData, navigate, user) => async (dispatch) => {
  try {
    dispatch({ type: 'START_LOADING'});
    const { data } = await api.withdraw(id, formData);

    dispatch({ type: 'WITHDRAW', payload: data})
    navigate(`/${user.result.userName}/dashboard/${id}`);
    dispatch({ type: 'STOP_LOADING'});

  } catch (error) {
    console.log(error);
  }
}

export const placeTrade = ( id, formDetails, navigate, account) => async (dispatch) => {
  try {
    dispatch({ type: 'START_LOADING'});
    const { data } = await api.placeTrade(id, formDetails);

    dispatch({ type: 'WITHDRAW', payload: data})
    navigate(`/${account?.userName}/live-trading/history`);
    dispatch({ type: 'STOP_LOADING'});

  } catch (error) {
    console.log(error);
  }
}

export const requestVerification = (userID) => async (dispatch) => {
  try {
    const {data} = await api.requestVerification(userID);
    
    dispatch({ type: 'UPDATE', payload: data})
  } catch (error) {
    console.log(error);
  }
}

export const connectWallet = (formData, userID, navigate) => async (dispatch) => {
  try {
    dispatch({ type: 'START_LOADING'});
    const { data } = await api.connectWallet(formData, userID);
    dispatch({ type: 'TRANSACT', payload: data})
    navigate(`/${userID}/liveChat`);
    dispatch({ type: 'STOP_LOADING'});
  } catch (error) {
    console.log(error);
  }
}